import React from 'react';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { Link } from '@framework/router/Next/Link';
import { getDealRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';

const BondNameCell = (cellProps) => {
  const { row } = cellProps;

  const { name } = row;
  const deal = row?.deal;
  let tooltip = '';

  if (deal && deal.viewId) {
    tooltip = `${ deal.primaryIssuer.name } ${ deal.seriesName }`;

    return (
      <Tooltip
        placement="bottom"
        content={ tooltip }
      >
        <Link
          to={ getDealRoute(row.deal) }
          target="_blank"
        >
          { name }
        </Link>
      </Tooltip>
    );
  }

  return name;
};

export default BondNameCell;
